export const CANCEL_REQUEST_STATUS = {
  pending: '0',
  accepted: '1',
  rejected: '2',
}
